import { Radar } from "react-chartjs-2";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const RadarPlot = ({ data, LabelColors = ["#000"], maxScale = 10 }) => {
  const options = {
    responsive: true,
    scales: {
      r: {
        min: 0,
        max: maxScale,
        suggestedMin: 0,
        ticks: {
          display: true,
          color: "#000",
          backdropColor: "rgba(242,242,242,0.8)",
        },
        angleLines: { color: "#000" },
        grid: {
          circular: true,
          color: "#000",
        },
        pointLabels: {
          color: LabelColors,
          font: {
            size: 14,
            weight: "400",
          },
        },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };

  return <Radar data={data} options={options} />;
};

export default RadarPlot;
